var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-anchor"},[(_vm.tourVisible)?_c('OnboardingTour',{attrs:{"step":_vm.currentStep,"index":_vm.stepIndex,"total":_vm.totalSteps,"is-last":_vm.isLastStep},on:{"next":_vm.next,"previous":_vm.previous,"skip":_vm.finish,"cta":_vm.openCta,"target-missing":_vm.onTargetMissing}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }